import { useCallback, useEffect } from 'react';

import { EVENT_READ_ALL_NOTIFICATION } from 'App/components/WebSocket';
import { markAllAsRead } from 'App/sources/Notifications';

import { useMutation, useQueryClient } from '@gogame/query';
import { useSocket } from '@gogame/sockets';

import { markAsReadALLKey, grid } from '../queryKeyFactory';

export const useSocketMarkAsReadAll = () => {
  const queryClient = useQueryClient();
  const socket = useSocket();

  const optimisticReadAll = useCallback(() => {
    queryClient.setQueryData(grid(), ({ list }) => ({
      unread: 0,
      list: list.map((notification) => ({
        ...notification,
        isRead: true,
      })),
    }));
  }, [queryClient]);

  useEffect(() => {
    socket.on(EVENT_READ_ALL_NOTIFICATION, optimisticReadAll);
    return () => {
      socket.off(EVENT_READ_ALL_NOTIFICATION, optimisticReadAll);
    };
  }, [socket]);

  const markAsReadMutation = useMutation(markAsReadALLKey(), markAllAsRead, {
    refresh: false,
    onMutate: async () => {
      optimisticReadAll();
    },
  });

  return [markAsReadMutation.mutateAsync, markAsReadMutation];
};
